import { render, staticRenderFns } from "./GongHuoCheckItemsTab.vue?vue&type=template&id=0210d334&scoped=true&"
import script from "./GongHuoCheckItemsTab.vue?vue&type=script&lang=js&"
export * from "./GongHuoCheckItemsTab.vue?vue&type=script&lang=js&"
import style0 from "./GongHuoCheckItemsTab.vue?vue&type=style&index=0&id=0210d334&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0210d334",
  null
  
)

export default component.exports